import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthenticationService } from '../../../../../services/authentication.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-tfaprofile-setup',
  templateUrl: './tfaprofile-setup.component.html',
  styleUrls: ['./tfaprofile-setup.component.scss'],
  providers: [MessageService],
})
export class TFAProfileSetupComponent implements OnInit {
  tfaForm: FormGroup = new FormGroup({
    code: new FormControl('', [
      Validators.required,
      (control) => {
        const value = control.value as string;
        if (value && value.length !== 6) {
          return { exactLength: true };
        }
        return null;
      },
    ]),
  });

  isBusy: boolean = false;
  isLoading: boolean = true;
  showError: boolean = false;
  errorMessage: string = '';
  qrInfo: string = '';
  authenticatorKey: string = '';

  constructor(
    private route: ActivatedRoute,
    public authService: AuthenticationService,
    public messageService: MessageService,
    private translate: TranslateService,
    public router: Router,
  ) {}

  ngOnInit() {
    this.generate2FAQrCode();
  }

  generate2FAQrCode() {
    this.authService
      .generate2FAQrCodeUri_Auth(this.authService.username)
      .subscribe((result) => {
        console.log('generate2FAQrCodeUri_Auth');
        console.log(result);

        this.authenticatorKey = result.manualEntryKey;
        this.qrInfo = result.setupQrCode;
        this.isLoading = false;
      });
  }

  validateControl(controlName: string) {
    return (
      this.tfaForm.get(controlName).invalid &&
      this.tfaForm.get(controlName).touched
    );
  }

  hasError(controlName: string, errorName: string) {
    return this.tfaForm.get(controlName).hasError(errorName);
  }

  enable2FA(tfaFormValue: any) {
    this.showError = false;
    this.errorMessage = '';
    this.isBusy = true;

    this.authService.enableUser2FA(tfaFormValue.code).subscribe(
      (result) => {
        this.isBusy = false;

        if (result.valid == false) {
          this.showError = true;
          this.errorMessage = 'Invalid code received.';
          return;
        }

        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'general.my_profile_form.message_tfa_disabled',
          ),
        });
        this.router.navigateByUrl('/store/myprofile');
      },
      (error) => {
        console.log('error');
        console.error(error);
        this.showError = true;
        this.errorMessage = 'Failed to validate code.';

        this.isBusy = false;
      },
    );
  }
}
